import axios from '../localAxios';
import { renameTeamURL } from './urls';

interface RenameTeamParams {
  teamId: string;
  name: string;
}

export async function renameTeam({ teamId, name }: RenameTeamParams) {
  const url = renameTeamURL(teamId);
  const result = await axios.put<{ data: string }>(url.href, { name });
  return result.data;
}
